import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { PermitEndpoint } from './permitendpoint.service';
import { PermitDto } from '../models/Permit.model';
import { DepartmentDto } from '../models/Department.model';
import { AgencyDto } from '../models/Agency.model';
import { PermitUpdateDto } from '../models/PermitUpdate.model';
import { PermitThemeVldDto } from '../models/PermitThemeVld.model';
import { PermitTypeVldDto } from '../models/PermitTypeVld.model';
import { VarianceExplanationVldDto } from '../models/VarianceExplanationVld.model';
import { ActionsTakenVldDto } from '../models/ActionsTakenVld.model';
import { BusinessRuleMessage } from '../models/BusinessRuleMessage.model';
import { ExternalDocumentDto } from '../models/ExternalDocument.model';
import { EntityStatus } from '../models/EntityStatus.model';
import { AutomaticYesAppliedVldDto } from '../models/AutomaticYesAppliedVld.model';
import { AutomaticYesEligibilityVldDto } from '../models/AutomaticYesEligibilityVld.model';
import { AutomaticYesApproachVldDto } from '../models/AutomaticYesApproachVld.model';

@Injectable()

export class PermitService {
  constructor(private router: Router, private permitEndpoint: PermitEndpoint) {
  }

  getPermitTypes() {
    return this.permitEndpoint.getPermitTypes<PermitTypeVldDto[]>();
  }

  getPermitThemes() {
    return this.permitEndpoint.getPermitThemes<PermitThemeVldDto[]>();
  }

  getActionsTakens() {
    return this.permitEndpoint.getActionsTakens<ActionsTakenVldDto[]>();
  }

  getVarianceExplanations() {
    return this.permitEndpoint.getVarianceExplanations<VarianceExplanationVldDto[]>();
  }

  getAllPermits(userProfileID?: string, departmentId?: string, legislationID?: string, agencyID?: string) {
    return this.permitEndpoint.getAllPermits<PermitDto[]>(userProfileID, departmentId, legislationID, agencyID);
  }

  getPermit(permitID?: string) {
    return this.permitEndpoint.getPermit<PermitDto>(permitID);
  }

  submitPermit(permit: PermitDto) {
    return this.permitEndpoint.submitPermit<BusinessRuleMessage[]>(permit);
  }

  getAutomaticYesEligibilityVlds() {
    return this.permitEndpoint.getAutomaticYesEligibilityVlds<AutomaticYesEligibilityVldDto[]>();
  }

  getAutomaticYesAppliedVlds() {
    return this.permitEndpoint.getAutomaticYesAppliedVlds<AutomaticYesAppliedVldDto[]>();
  }

  getAutomaticYesApproachVlds() {
    return this.permitEndpoint.getAutomaticYesApproachVlds<AutomaticYesApproachVldDto[]>();
  }

  async uploadPermitDocument(externalDocuments: ExternalDocumentDto[]) {
    let response = [];
    const formData = new FormData();
    var docs = externalDocuments.filter(i => i.itemStatus == EntityStatus.New);
    for (let externalDocument of docs) {
      if (externalDocument.file != null) {
        formData.append(externalDocument.file.name, externalDocument.file);
      }
    }
    if (formData != null && docs.length > 0) {
      formData.append('folderkey', docs[0].permitID);
      await this.permitEndpoint.uploadPermitDocument(formData);
    }

    return response;
  }
}
